<template>
  <div id="app">
    <login></login>
  </div>
</template>

<script>
import login from '@/components/login'
export default {
  name: 'App',
  components: {
    login
  }
}
</script>

<style lang="scss">
*{padding: 0;margin: 0;box-sizing: border-box;}
.el-select-dropdown__item.selected{color: #FF8F40;}

</style>
